const normalizeText = (value) => `${value || ''}`.trim();

const hasText = (value) => normalizeText(value).length > 0;

const normalizeComparableText = (value) => normalizeText(value).replace(/\s+/g, ' ').toLowerCase();

const normalizeEmail = (value) => normalizeComparableText(value);

const normalizeDigits = (value) => normalizeText(value).replace(/\D/g, '');

const normalizeAlphaNumeric = (value) => normalizeText(value).replace(/[^0-9a-z]/gi, '').toUpperCase();

const normalizeIsoDate = (value) => {
    const normalized = normalizeText(value);

    if (!normalized) {
        return '';
    }

    if (/^\d{4}-\d{2}-\d{2}$/.test(normalized)) {
        return normalized;
    }

    const dateMatch = normalized.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

    if (dateMatch) {
        const [, day, month, year] = dateMatch;
        return `${year}-${month}-${day}`;
    }

    return normalized.slice(0, 10);
};

const filterNamedPartners = (items = []) => (
    items
        .filter((item) => item && item.idUsuario != null && hasText(item.Nome))
        .map((item) => ({
            ...item,
            Nome: normalizeText(item.Nome),
            Sobrenome: normalizeText(item.Sobrenome)
        }))
);

const filterNamedPatients = (items = []) => (
    items
        .filter((item) => item && item.idPacientes != null && hasText(item.nome))
        .map((item) => ({
            ...item,
            nome: normalizeText(item.nome)
        }))
);

const findDuplicatePatientRecord = (items = [], candidate = {}) => {
    const candidateId = Number(candidate.idPacientes || candidate.id) || 0;
    const normalizedCandidate = {
        nome: normalizeComparableText(candidate.nome),
        datanascimento: normalizeIsoDate(candidate.datanascimento),
        rg: normalizeAlphaNumeric(candidate.rg),
        cpf: normalizeDigits(candidate.cpf)
    };

    for (const item of items) {
        if (!item || Number(item.idPacientes) === candidateId) {
            continue;
        }

        if (normalizedCandidate.cpf && normalizeDigits(item.cpf) === normalizedCandidate.cpf) {
            return { field: 'cpf', item };
        }

        if (normalizedCandidate.rg && normalizeAlphaNumeric(item.rg) === normalizedCandidate.rg) {
            return { field: 'rg', item };
        }

        if (
            normalizedCandidate.nome
            && normalizedCandidate.datanascimento
            && normalizeComparableText(item.nome) === normalizedCandidate.nome
            && normalizeIsoDate(item.datanascimento) === normalizedCandidate.datanascimento
        ) {
            return { field: 'nomeDataNascimento', item };
        }
    }

    return null;
};

const getDuplicatePatientMessage = (items = [], candidate = {}) => {
    const duplicate = findDuplicatePatientRecord(items, candidate);

    if (!duplicate) {
        return '';
    }

    if (duplicate.field === 'cpf') {
        return `Ja existe um paciente cadastrado com este CPF (ID ${duplicate.item.idPacientes}).`;
    }

    if (duplicate.field === 'rg') {
        return `Ja existe um paciente cadastrado com este RG (ID ${duplicate.item.idPacientes}).`;
    }

    return `Ja existe um paciente cadastrado com este nome e data de nascimento (ID ${duplicate.item.idPacientes}).`;
};

const findDuplicatePartnerRecord = (items = [], candidate = {}) => {
    const candidateId = Number(candidate.idUsuario || candidate.id) || 0;
    const normalizedCandidate = {
        email: normalizeEmail(candidate.Email || candidate.email),
        nome: normalizeComparableText(candidate.Nome || candidate.userName),
        sobrenome: normalizeComparableText(candidate.Sobrenome || candidate.sobrenome),
        telefone: normalizeDigits(candidate.Telefone || candidate.tel)
    };

    for (const item of items) {
        if (!item || Number(item.idUsuario) === candidateId) {
            continue;
        }

        if (normalizedCandidate.email && normalizeEmail(item.Email) === normalizedCandidate.email) {
            return { field: 'email', item };
        }

        if (
            !normalizedCandidate.email
            && normalizedCandidate.nome
            && normalizedCandidate.sobrenome
            && normalizedCandidate.telefone
            && normalizeComparableText(item.Nome) === normalizedCandidate.nome
            && normalizeComparableText(item.Sobrenome) === normalizedCandidate.sobrenome
            && normalizeDigits(item.Telefone) === normalizedCandidate.telefone
        ) {
            return { field: 'identity', item };
        }
    }

    return null;
};

const getDuplicatePartnerMessage = (items = [], candidate = {}) => {
    const duplicate = findDuplicatePartnerRecord(items, candidate);

    if (!duplicate) {
        return '';
    }

    if (duplicate.field === 'email') {
        return `Ja existe um usuario cadastrado com este e-mail (ID ${duplicate.item.idUsuario}).`;
    }

    return `Ja existe um usuario cadastrado com o mesmo nome, sobrenome e telefone (ID ${duplicate.item.idUsuario}).`;
};

export {
    filterNamedPartners,
    filterNamedPatients,
    getDuplicatePartnerMessage,
    getDuplicatePatientMessage,
    hasText,
    normalizeText
};
